import { Injectable } from '@angular/core';

import { MockAccount } from '../account/account.mock';
import { MockConfirmation } from '../confirmation/confirmation.mock';

@Injectable({
   providedIn: 'root'
})
export class MockService {

   constructor() { }

   mock( url: string, body? ): any {
      return JSON.parse( JSON.stringify( this.wrap( url.match( /((?:\/?[a-zA-Z_]+)+)(\/[\w-]+)?(\?.*)?$/ ), body )));
   }

   wrap( parsedURL, body? ) {
      console.log( '* mock', parsedURL );
      if ( body ) { console.log( '* mock - passed body', body ); }

      const [ , url, id, queryParams ] = parsedURL;
      console.log( 'mocking url', url );

      if ( id ) { console.log( '* mock - found id', id ); }

      if ( queryParams ) { console.log( '* mock - queryParams', queryParams ); }

      switch ( url ) {
         case 'POSTaccount':
            return new MockAccount();
         case '/payments/confirmation':
            return new MockConfirmation();
         case '/payments/confirmation/email':
            return true;
      }

      return {};
   }
}
